import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IEmptyResult } from '~src/httpClient/serverApi/types/IResponse';
import { SelfServiceSchedule } from '~src/schedule/serverApi/types/SelfServiceSchedule';

import { LinkedTaskItem } from '../types/LinkedTaskItem';

export type CreateLinkedTaskSelfServiceSchedulesParams = {
  readonly schedule: SelfServiceSchedule;
  readonly linkedTaskItems: LinkedTaskItem[];
}

export class CreateLinkedTaskSelfServiceSchedulesRequest extends Request<CreateLinkedTaskSelfServiceSchedulesParams, IEmptyResult> {
  constructor(params: CreateLinkedTaskSelfServiceSchedulesParams) {
    super('createLinkedTaskSelfServiceSchedules', params);
  }
}
